import angular from 'angular';
import ngMessages from 'angular-messages';
import {
  loaderService,
  supportSharedModelService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './add-support-ticket-attachment-dialog.controller';
import template from './add-support-ticket-attachment-dialog.html';

const messagesTpl = require('./messages/messages.required.html');
const phoneMessagesTpl = require('./messages/messages.phone.html');
const emailMessagesTpl = require('./messages/messages.email.html');
const uploadMessagesTpl = require('./messages/messages.upload.html');

export class dialogService {
  getOptions($event, {
    ticketType = 1,
    ticket,
    displayList,
    refreshTicket,
  }) {
    return {
      controller,
      controllerAs: 'addSupportTicketAttachmentDialogVM',
      locals: {
        ticketType,
        ticket,
        displayList,
        refreshTicket,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
      bindToController: true,
    };
  }
}

export default angular.module('app.components.global.addSupportTicketAttachmentDialog', [
  ngMessages,
  ssDialogService,
  alerts,
  loaderService,
  supportSharedModelService,
])
  .service('addSupportTicketAttachmentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('messages.required.html', messagesTpl);
    $templateCache.put('messages.phone.html', phoneMessagesTpl);
    $templateCache.put('messages.email.html', emailMessagesTpl);
    $templateCache.put('messages.upload.html', uploadMessagesTpl);
  })
  .name;

console.log('app.components.global.addSupportTicketAttachmentDialog created');
